(function () {
  if (window.pepiGridControls) return;
  window.pepiGridControls = true;
  var mobile = matchMedia('(max-width: 767px)');
  var tablet = matchMedia('(max-width: 1024px)');
  var en = document.documentElement.lang.indexOf('en') === 0;
  var mode, choices, columns;
  function configure() {
    mode = mobile.matches ? 'mobile' : tablet.matches ? 'tablet' : 'desktop';
    choices = mode === 'mobile' ? [1, 2] : mode === 'tablet' ? [2, 3] : [3, 4, 5, 6, 7];
    columns = mode === 'mobile' ? 2 : mode === 'tablet' ? 3 : 6;
    try {
      var saved = Number(localStorage.getItem(mode === 'desktop' ? 'pc-catalog-columns' : 'pc-catalog-columns-' + mode));
      if (choices.indexOf(saved) !== -1) columns = saved;
    } catch (e) {}
  }
  function icon(count) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    var width = count > 4 ? 30 : 24;
    svg.setAttribute('viewBox', '0 0 ' + width + ' 16');
    svg.setAttribute('width', width);
    svg.setAttribute('height', '16');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var gap = 2;
    var cell = (width - 2 - (count - 1) * gap) / count;
      for (var col = 0; col < count; col++) {
        var rect = document.createElementNS(ns, 'rect');
        rect.setAttribute('x', 1 + col * (cell + gap));
        rect.setAttribute('y', 1);
        rect.setAttribute('width', cell);
        rect.setAttribute('height', '14');
        svg.appendChild(rect);
      }
    return svg;
  }
  function apply() {
    document.querySelectorAll('.t4s-collection-page .t4s-products').forEach(function (grid) {
      if (grid.dataset.pcColumns !== String(columns)) {
        grid.dataset.pcColumns = columns;
        grid.style.setProperty('--pc-columns', columns);
      }
    });
    document.querySelectorAll('[data-pc-grid-ui] button').forEach(function (button) {
      button.setAttribute('aria-pressed', String(Number(button.dataset.columns) === columns));
    });
  }
  function mount() {
    document.querySelectorAll('.t4s-collection-page .t4s-collection-header').forEach(function (header) {
      var group = header.querySelector('.pc-grid-density');
      if (!group) {
        group = document.createElement('div');
        group.className = 'pc-grid-density';
        header.appendChild(group);
      }
      if (group.dataset.pcGridUi === mode) return;
      group.replaceChildren();
      group.dataset.pcGridUi = mode;
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', en ? 'Product grid layout' : 'Disposition des produits');
      choices.forEach(function (count) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.columns = count;
        var label = en ? count + (count === 1 ? ' column' : ' columns') : count + (count === 1 ? ' colonne' : ' colonnes');
        button.setAttribute('aria-label', label);
        button.title = label;
        button.appendChild(icon(count));
        button.addEventListener('click', function () {
          columns = count;
          try { localStorage.setItem(mode === 'desktop' ? 'pc-catalog-columns' : 'pc-catalog-columns-' + mode, count); } catch (e) {}
          apply();
        });
        group.appendChild(button);
      });
    });
    apply();
  }
  function resize() { configure(); mount(); }
  configure();
  mount();
  mobile.addEventListener('change', resize);
  tablet.addEventListener('change', resize);
  var pending = false;
  new MutationObserver(function (records) {
    if (pending) return;
    // Product cards and badges do not change the layout controls.
    var selector = '.t4s-collection-header, .t4s-products';
    var replaced = records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
      });
    });
    if (!replaced) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; mount(); });
  }).observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
})();
